import { render, staticRenderFns } from "./BaseAddressImport.vue?vue&type=template&id=4cd6ee52&scoped=true"
import script from "./BaseAddressImport.vue?vue&type=script&lang=js"
export * from "./BaseAddressImport.vue?vue&type=script&lang=js"
import style0 from "./BaseAddressImport.vue?vue&type=style&index=0&id=4cd6ee52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd6ee52",
  null
  
)

export default component.exports